module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img60.5010c068.jpg";